"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentationModule = void 0;
var all_settings_1 = require("@src/const/documentations/all-settings");
var cash_dom_1 = __importDefault(require("cash-dom"));
var input_mapping_const_1 = require("../../const/input.mapping.const");
var module_mapping_1 = require("../../const/module.mapping");
var parse_settings_string_1 = require("./helper/parse-settings-string");
var DocumentationModule = /** @class */ (function () {
    function DocumentationModule() {
        // navigation
        this.allModules = [];
        this.otherNavEntries = [];
    }
    DocumentationModule.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.references = this.module.references;
                this.settingsJSON = (0, parse_settings_string_1.convertTypeScriptToJSON)(all_settings_1._AllSettingsString);
                console.log('documentation module', this.module, 'refs', this.module.references);
                this.generateModuleDocumentation();
                this.generateGetterSetterDocumentation();
                this.generateAllSettings();
                this.generateSidebarNavigation();
                return [2 /*return*/];
            });
        });
    };
    DocumentationModule.prototype.generateSidebarNavigation = function () {
        var _a;
        var container = (_a = this.references.sidebarNavigation) === null || _a === void 0 ? void 0 : _a.domElement;
        if (container === null || container === void 0 ? void 0 : container.length) {
            var sideNavData = __spreadArray([
                {
                    label: 'Modules',
                    icon: 'blueprint',
                    path: '#testing',
                    childNavigation: __spreadArray([], this.allModules.map(function (module) { return ({
                        path: '#' + module,
                        label: module.replace(/-/g, " "),
                    }); }), true),
                }
            ], (this.otherNavEntries ? [
                {
                    label: 'Other',
                    icon: 'blueprint',
                    path: '#testing',
                    childNavigation: __spreadArray([], this.otherNavEntries.map(function (module) { return ({
                        path: '#' + module,
                        label: module.replace(/-/g, " "),
                    }); }), true),
                }
            ] : []), true);
            var sidebarNav = (0, cash_dom_1.default)("<ci-side-navigation></ci-side-navigation>");
            sidebarNav.data('sideNavData', sideNavData);
            sidebarNav.attr('data', JSON.stringify(sideNavData));
            sidebarNav.attr('appName', 'LOGISTIFY');
            this.$container.prepend(sidebarNav);
            sidebarNav.attr('data', JSON.stringify(sideNavData));
        }
        else {
            console.error('Missing sidebarnav data-ref');
        }
    };
    DocumentationModule.prototype.generateModuleDocumentation = function () {
        var _this = this;
        if (this.references.moduleMapping.domElement.length) {
            var moduleDocumentation = Object.entries(module_mapping_1._AllModuleBlueprints).map(function (_a) {
                var moduleName = _a[0];
                var readableKey = _this.formatKey(moduleName);
                var attributes = __assign(__assign({}, (module_mapping_1._AllModuleBlueprints[moduleName].references || {})), (module_mapping_1._AllModuleBlueprints[moduleName].docuAdditions || {}));
                var baseElement = _this.references.moduleMapping.domElement.get(0);
                var clonedElement = (0, cash_dom_1.default)(baseElement.cloneNode(true)); // deep clone
                clonedElement.attr("id", moduleName);
                _this.allModules.push(moduleName);
                var moduleTemplate = (0, cash_dom_1.default)(clonedElement[0].outerHTML);
                var attributeContainer = moduleTemplate.find("[data-ref='attribute-mapping']");
                if (attributeContainer) {
                    var attributeDocumentation = Object.entries(attributes).map(function (_a) {
                        var _b, _c, _d, _e;
                        var attributeName = _a[0], attributeRef = _a[1];
                        var html = attributeContainer.prop("outerHTML")
                            .replace(/\{\{module.att.dataTag\}\}/g, (_b = attributeRef.dataTag) !== null && _b !== void 0 ? _b : 'ref')
                            .replace(/\{\{module.att.name\}\}/g, attributeRef.uid)
                            .replace(/\{\{module.att.required\}\}/g, '' + ((_c = attributeRef.required) !== null && _c !== void 0 ? _c : 'true'))
                            .replace(/\{\{module.att.description\}\}/g, (_d = attributeRef.description) !== null && _d !== void 0 ? _d : '')
                            .replace(/\{\{module.att.cssClasses\}\}/g, ((_e = attributeRef.cssClasses) !== null && _e !== void 0 ? _e : []).join(', ') || '-');
                        return html;
                    });
                    for (var _i = 0, attributeDocumentation_1 = attributeDocumentation; _i < attributeDocumentation_1.length; _i++) {
                        var e = attributeDocumentation_1[_i];
                        attributeContainer.parent().append(e);
                    }
                    attributeContainer.remove();
                }
                var legacyKey = module_mapping_1._ModuleToSettingsMapping[moduleName];
                var settingsObject = legacyKey ? _this.settingsJSON[legacyKey] : undefined;
                var settingsObjectString = settingsObject ? '<ci-code>' + JSON.stringify(settingsObject, null, 2) + '</ci-code>' : 'none';
                var html = moduleTemplate.prop('outerHTML')
                    .replace(/\{\{module.name\}\}/g, 'Module: ' + readableKey)
                    .replace(/\{\{module.ref\}\}/g, moduleName)
                    .replace(/\{\{module.description\}\}/g, '')
                    .replace(/\{\{module.settingsObject\}\}/g, settingsObjectString)
                    .replace(/\{\{module.legacy\}\}/g, legacyKey !== null && legacyKey !== void 0 ? legacyKey : 'None');
                return html;
            });
            this.references.moduleMapping.parent.get(0).innerHTML += moduleDocumentation.join('');
        }
    };
    // generate an overview of the current getter and setter
    DocumentationModule.prototype.generateGetterSetterDocumentation = function () {
        var _this = this;
        var _a;
        if ((_a = this.references.getterMappingEntry.domElement) === null || _a === void 0 ? void 0 : _a.length) {
            this.references.getterMappingEntry.parent.attr("id", "getter-setter");
            this.otherNavEntries.push("getter-setter");
            var getterDocumentationEntries = Object.entries(input_mapping_const_1._AllMappings).map(function (_a) {
                var _b, _c;
                var key = _a[0], value = _a[1];
                var readableKey = _this.formatKey(key);
                var val = value;
                var entryTemplate = _this.references.getterMappingEntry.domElement.get(0).outerHTML;
                entryTemplate = entryTemplate
                    .replace(/\{\{getter.name\}\}/g, readableKey)
                    .replace(/\{\{getter.get\}\}/g, val.uid)
                    .replace(/\{\{getter.type\}\}/g, val.type)
                    .replace(/\{\{getter.id\}\}/g, ((_b = val.legacy) === null || _b === void 0 ? void 0 : _b.id) || '')
                    .replace(/\{\{getter.localStorage\}\}/g, ((_c = val.legacy) === null || _c === void 0 ? void 0 : _c.localStorage) || '');
                return entryTemplate;
            });
            this.references.getterMappingEntry.parent.get(0).innerHTML +=
                getterDocumentationEntries.join('');
        }
    };
    DocumentationModule.prototype.formatKey = function (key) {
        // Convert the first character to uppercase and insert a space before each uppercase letter
        // that follows a lowercase letter or another uppercase letter
        return key
            .replace(/([A-Z])/g, ' $1') // Insert space before uppercase letters
            .replace(/-/g, ' ') // Replace dash with space
            .replace(/^./, function (str) { return str.toUpperCase(); }) // Capitalize the first character
            .trim(); // Remove leading space if present
    };
    DocumentationModule.prototype.generateAllSettings = function () {
        var _a;
        var container = (_a = this.module.references.allSettings) === null || _a === void 0 ? void 0 : _a.domElement;
        if (container) {
            this.module.references.allSettings.domElement.attr("id", "all-settings");
            this.otherNavEntries.push("all-settings");
            container.html(all_settings_1._AllSettingsString);
        }
    };
    return DocumentationModule;
}());
exports.DocumentationModule = DocumentationModule;
